// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// import { getDatabase } from "firebase/database";
// import { getAuth } from "firebase/auth";

// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyDatfHnAqmCL49vHJVua_wtxrA27G8D4sg",
//   authDomain: "alqaimwelfare-foundation.firebaseapp.com",
//   databaseURL: "https://alqaimwelfare-foundation-default-rtdb.firebaseio.com",
//   projectId: "alqaimwelfare-foundation",
//   storageBucket: "alqaimwelfare-foundation.appspot.com",
//   messagingSenderId: "954400279985",
//   appId: "1:954400279985:web:c12429cf63a31e2fccc190",
//   measurementId: "G-WKGKWTT26Y",
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
// const database = getDatabase(app);

// export const auth = getAuth(app);
// export { database };

// Import the functions you need from the SDKs you need
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// import { getStorage } from "firebase/storage";  
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBynf4LDgd2JUNTOBkBvdFfX8sdCBJXkYo",
  authDomain: "alqaim-welfarefoundation.firebaseapp.com",
  projectId: "alqaim-welfarefoundation",
  storageBucket: "alqaim-welfarefoundation.firebasestorage.app",
  messagingSenderId: "800316706278",
  appId: "1:800316706278:web:bcf07716635b69431f1a27",
  measurementId: "G-2LVBQ8N2C2",
};

// Initialize Firebase
const app = !getApps().length
  ? initializeApp(firebaseConfig)
  : getApp();
const analytics = getAnalytics(app);

export const db = getFirestore(app);
export const auth = getAuth(app);
// export const storage = getStorage(app);  
